import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  addChild,
  getAssessmentDetails,
  getpickListData,
  getUserQuestionnairestatuses,
  sendSmsForChildAdd,
  tbluserquestionnairestatuses } from
"../../../services/liferay/baraemServices";
import {
  calculateAdjustedAgeInMonths,
  configureFirstIframe,
  getLastNineCharacters,
  isArabic } from
"../../../utils/util";
import AlertDependent from "../../../common/AlertDependent";
import ChildAddedPopup from "./ChildAddedPopup";
import DatePicker from "react-datepicker";
import Country from "../../../common/Country";
import { config } from "../../../utils/constants";
import { Loader } from "../../../common/Loader";

const AddNonDubaiHealthChild = ({
  setStep,
  translationMap,
  isDubaiHealthFacility,
  patientFirstName,
  patientSex,
  dateOfBirth,
  patientMobile,
  healthCardNumber,
  ageInMonth
}) => {
  const navigate = useNavigate();
  const [childName, setChildName] = useState("");
  const [dob, setDob] = useState(null);
  const [gender, setGender] = useState("");
  const [hospital, setHospital] = useState("");
  const [nurserySchoolName, setNurserySchoolName] = useState("");
  const [followUpHospital, setFollowUpHospital] = useState("");
  const [bornIn, setBornIn] = useState("");
  const [diagnosedDisability, setDiagnosedDisability] = useState("");
  const [disabilities, setDisabilities] = useState("");
  const [otherDisability, setOtherDisability] = useState("");
  const [noDubaiHcNumber] = useState("");
  const [prematurity, setPrematurity] = useState("37WeeksOrMore");
  const [bornInDubai, setBornInDubai] = useState(null);
  const [isDiagnosed, setIsDiagnosed] = useState(null);
  const [dubaiHospitalData, setDubaiHospitalsData] = useState([]);
  const [disabillitiesList, setDisabillitiesList] = useState([]);
  const [error, setError] = useState(false);
  const [showAddChildPopup, setShowAddChildPopup] = useState(false);
  const [ageInMonths, setAgeInMonths] = useState(0);
  const [nationality, setNationality] = useState("");
  const [pregnancyDurationList, setPregnancyDurationList] = useState([]);
  const [otherHospitalsData, setOtherHospitalsData] = useState([]);
  const [, setCountryLoading] = useState(false);
  const [isAddButtonDisable, setisAddButtonDisable] = useState(false);
  const [isApiLoading, setIsApiLoading] = useState(false);

  const [base64, setBase64] = useState(null);
  const [, setFileName] = useState("");
  const [bornInError, setBornInError] = useState(false);
  const [disabilityError, setDisabilityError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [dobError, setDobError] = useState(false);
  const [otherDisabilityError, setOtherDisabilityError] = useState(false);
  const [hospitalError, setHospitalError] = useState(false);
  const [selectdisabilityError, setSelectDisabilityError] = useState(true);
  const [countryCodeError, setCountryCodeError] = useState(false);
  const [imgErrorMessage, setImgErrorMessage] = useState("");
  const [imageError, setImageError] = useState(false);
  const [genderError, setGenderError] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (patientSex) {
      setGender(patientSex);
    }
  }, [patientSex]);

  const today = new Date();

  const sixYearsAgo = new Date();
  sixYearsAgo.setFullYear(today.getFullYear() - 6);

  const maxDate = new Date(today.setDate(today.getDate() - 1))
  .toISOString()
  .split("T")[0];
  const minDate = sixYearsAgo.toISOString().split("T")[0];
  const handleChildNameChange = (e) => {
    const validValue = e.target.value.replace(/[^A-Za-z\u0600-\u06FF\s]/g, "");
    setChildName(validValue);
    if (validValue !== "") {
      setNameError(false);
    }
  };
  const handleDobChange = (date) => {
    const age = calculateAgeInMonths(dob);
    setAgeInMonths(age);
    setDob(date);
    setDobError(false);
  };

  const handleGenderChange = (e) => {
    setGender(e.target.value);
    setGenderError(false);
  };
  const handleBornInChange = (value) => {
    setHospital(value);
    setBornInDubai(value);
    setBornIn("");
    setHospitalError(false);
  };

  const handleChangeHospital = (e) => {
    const value = e.target.value;
    setBornIn(value);
    if (value) {
      setBornInError(false);
    }
  };

  const handleDiagnosisChange = (value) => {
    setIsDiagnosed(value);
    setDisabilities(value);
    setDiagnosedDisability("");
    setOtherDisability("");
    setDisabilityError(false);
    setSelectDisabilityError(false);
  };

  const handleDisabilities = (e) => {
    setDiagnosedDisability(e.target.value);
    setSelectDisabilityError(false);
  };

  const handleChangeNationality = (e) => {
    setNationality(e.target.value);
    setCountryCodeError(false);
  };
  const handlePrematurityWeekChange = (e) => {
    setPrematurity(e.target.value);
  };

  const capitalizeEachWord = (sentence) =>
  sentence
  .split(" ")
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join(" ");

  const convertFileToBase64 = async (file) => {
    try {
      const reader = new FileReader();

      return await new Promise((resolve, reject) => {
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
      });
    } catch (error) {
      console.error("Error converting file to Base64:", error);
      throw error;
    }
  };
  const handleFileChange = async (event) => {
    setImgErrorMessage("");
    setImageError(false);
    const file = event.target.files[0];
    if (file) {
      try {
        const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
        const maxSizeInMB = 5;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

        let errorMessage = "";

        if (!allowedTypes.includes(file.type)) {
          errorMessage =
          translationMap?.imageFormateError ??
          "Please upload a valid image file (PNG, JPG, JPEG).";
        } else if (file.size > maxSizeInBytes) {
          errorMessage =
          translationMap?.imageSizeError ??
          "File size must be less than 5MB.";
        }

        if (errorMessage) {
          setImgErrorMessage(errorMessage);
          setImageError(true);
          return;
        }
        const tempImageURL = URL.createObjectURL(file);
        setSelectedImage(tempImageURL);
        const base64String = await convertFileToBase64(file);
        setBase64(base64String);
        setFileName(file.name);
      } catch (error) {
        console.error("Error converting file:", error);
      }
    }
  };

  const extractWeeks = (duration) => {
    const match = duration.match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  };

  const computePrematurity = (pregnancyDuration) => {
    const weeks = extractWeeks(pregnancyDuration);
    return Math.max(0, 40 - weeks);
  };

  const formatToApiDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const calculateAgeInMonths = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    const years = today.getFullYear() - birth.getFullYear();
    const months = today.getMonth() - birth.getMonth();
    return years * 12 + months + (today.getDate() >= birth.getDate() ? 0 : -1);
  };

  const validateForm = () => {
    let hasError = false;

    if (
    (isDubaiHealthFacility ? !patientFirstName : !childName.trim()) ||
    !disabilities ||
    !gender ||
    !nationality ||
    !bornIn || (
    isDubaiHealthFacility ? !dateOfBirth : !dob))
    {
      hasError = true;
      setError(true);

      !bornIn ? setBornInError(true) : setBornInError(false);
      !disabilities ? setDisabilityError(true) : setDisabilityError(false);
      isDubaiHealthFacility ?
      !patientFirstName.trim() ?
      setNameError(true) :
      setNameError(false) :
      !childName.trim() ?
      setNameError(true) :
      setNameError(false);

      isDubaiHealthFacility ?
      !dateOfBirth ?
      setDobError(true) :
      setDobError(false) :
      !dob ?
      setDobError(true) :
      setDobError(false);
      !nationality ? setCountryCodeError(true) : setCountryCodeError(false);
    }

    if (gender === "") {
      hasError = true;
      setGenderError(true);
    }

    if (diagnosedDisability === "other" && !otherDisability.trim()) {
      hasError = true;
      setOtherDisabilityError(true);
    }

    if (isDiagnosed === "yes" && !diagnosedDisability.trim()) {
      hasError = true;
      setSelectDisabilityError(true);
    }

    if (bornIn === "") {
      hasError = true;
      setHospitalError(true);
    }

    return hasError ? false : true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isNonDubaiFormValid = validateForm();
    if (!isNonDubaiFormValid) {
      return;
    } else {
      window.parent.scrollTo(0, 0);

      setisAddButtonDisable(true);
      setIsApiLoading(true);

      let data = {
        baraemUserId: "",
        base64: base64,
        bornIn: bornIn,
        diagnosedDisability: diagnosedDisability,
        disabilities: disabilities,
        dob: isDubaiHealthFacility ?
        new Date(dateOfBirth.split("/").reverse().join("-"))
        .toISOString()
        .split("T")[0] :
        formatToApiDate(dob),
        followUpHospital: followUpHospital,
        gender: isDubaiHealthFacility ? patientSex : gender,
        healthCardNumber: isDubaiHealthFacility ?
        healthCardNumber :
        noDubaiHcNumber,
        hospital: hospital,
        mobileNumber: patientMobile,
        name: capitalizeEachWord(
          isDubaiHealthFacility ? patientFirstName : childName
        ),
        nationality: nationality,
        nurserySchoolName: nurserySchoolName,
        otherDisability: otherDisability,
        prematurity: computePrematurity(prematurity)
      };
      // console.log("all data is ", data)

      const getAgeInMonths = isDubaiHealthFacility ?
      calculateAdjustedAgeInMonths(
        new Date(dateOfBirth.split("/").reverse().join("-"))
        .toISOString()
        .split("T")[0],
        computePrematurity(prematurity)
      ) :
      calculateAdjustedAgeInMonths(dob, computePrematurity(prematurity));

      if (getAgeInMonths <= 72) {
        const response = await addChild(data);


        if (response.status === 200) {
          try {
            const sendSMSResponse = await sendSmsForChildAdd(
              patientMobile,
              capitalizeEachWord(
                isDubaiHealthFacility ? patientFirstName : childName
              )
            );

            if (sendSMSResponse.status === 200) {

            } else {

            }
          } catch (error) {

          }
          const { childId } = response.data.data;

          const questionStatus = await getUserQuestionnairestatuses(
            healthCardNumber || childId
          );
          if (
          questionStatus.status === 200 &&
          questionStatus.data.data.totalCount === 0)
          {




            const assessment = await getAssessmentDetails();

            if (assessment.status === 200) {
              const questionnaireData = assessment.data.data;
              const userQuestionnaireStatusDataList = questionnaireData.items
              .map((item) => {
                let baraemStatus = null;

                if (
                getAgeInMonths >= item.fromage &&
                getAgeInMonths <= item.toage)
                {
                  baraemStatus = "pending";
                } else if (item.toage < getAgeInMonths) {
                  baraemStatus = "missed";
                } else if (item.fromage > getAgeInMonths) {
                  return null;
                }

                return {
                  attenddate: new Date().toISOString(),
                  baraemStatus,
                  baraemusername: childName,
                  childId: childId,
                  hcnumber: isDubaiHealthFacility ?
                  healthCardNumber :
                  childId,
                  questionnaireid: item.questionnaireid
                };
              })
              .filter((item) => item !== null);
              const userquestionnairestatuses =
              await tbluserquestionnairestatuses(
                userQuestionnaireStatusDataList
              );
              if (userquestionnairestatuses.status === 200) {
                setAgeInMonths(getAgeInMonths);
                setShowAddChildPopup(true);
              }
            }
          } else {
            setAgeInMonths(getAgeInMonths);
            setShowAddChildPopup(true);
          }
          setIsApiLoading(false);
          window.parent.scrollTo(0, 0);
        } else {
          setIsApiLoading(false);
          setisAddButtonDisable(false);
          console.error(`Unexpected response: ${response.status}`);
        }
      } else {
        setIsApiLoading(false);
        setisAddButtonDisable(false);
        navigate("/", {
          state: {
            childAddError: true
          }
        });
      }
    }
  };

  useEffect(() => {
    configureFirstIframe(1000, 2200, true);
    const fetchHospitals = async () => {
      try {
        const dubaiHospitalList = await getpickListData(
          "dubai-health-hospitals"
        );
        const disabillitiesList = await getpickListData(
          "disability-developmental-delay"
        );
        const pregnancyDurationList = await getpickListData(
          "pregnancy-duration"
        );
        const otherHospitalsList = await getpickListData(
          "other-nondubai-hospitals"
        );

        if (dubaiHospitalList.status === 200) {
          const listTypeEntries = dubaiHospitalList.data.data.listTypeEntries;
          setDubaiHospitalsData(listTypeEntries);
        }
        setDisabillitiesList(disabillitiesList.data.data.listTypeEntries);
        setPregnancyDurationList(
          pregnancyDurationList.data.data.listTypeEntries
        );
        setOtherHospitalsData(otherHospitalsList.data.data.listTypeEntries);
      } catch (err) {
        console.error(err);
      }
    };
    fetchHospitals();
  }, []);

  if (isApiLoading) {
    return <Loader />;
  }

  return (
    <div>
      <section
        className="w-100 clearfix BaraemMainSection"
        id="CoverPlanActive"
        style={{
          marginTop: "30px"
        }}>
        
        <div className="container customContainer2">
          <div className="Title_Inner_Box">
            <h6 className="MainTitleOne">
              {translationMap?.addChild ?? "Add Child"}
            </h6>
          </div>
          <div className="Step_ul_main_box">
            <ul className="Step_Info_ul_box">
              <li>
                <div className="Step_inner_box completed_box">
                  <div className="inner_counter_wrap inner_counter_wrap_filled">
                    <span className="count_box">
                      <i className="material-symbols-outlined">check</i>
                    </span>

                    <p>{translationMap?.regMethod ?? "Registration method"}</p>
                  </div>
                  <div className="inner_counter_wrap inner_counter_wrap2">
                    <div className="count_box">
                      1
                      <span className="green_circle">
                        <i className="material-symbols-outlined">check</i>
                      </span>
                    </div>
                    <p onClick={() => setStep(-1)}>
                      {translationMap?.edit ?? "Edit"}
                    </p>
                  </div>
                </div>
              </li>
              <li>
                <div className="Step_inner_box active_box edit_box_border ">
                  <div className="inner_counter_wrap">
                    <span className="count_box">2</span>
                    <p>
                      {translationMap?.personalInfo ?? "Personal Information"}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="container customContainer customContainer3">
          <div className="cover_inner_wrapper">
            <div className="cover_main_box1">
              {error &&
              <AlertDependent
                setError={setError}
                alert_text={
                translationMap?.unableToAddChild ?? "Unable to add child"
                }
                number_text={
                translationMap?.mandatoryInformationText ??
                "Please verify on the form the mandatory information pending."
                } />

              }
              {imageError &&
              <AlertDependent
                setError={setImageError}
                alert_text={imgErrorMessage} />

              }
              <div className="baraem_main_inner_wrapper baraem_main_inner_form_wrapper">
                <form className="form_box radio_form" onSubmit={handleSubmit}>
                  <div className="Inner_Box">
                    <div className="row">
                      <div className="col-12 col-md-12 col-lg-12">
                        <div className="image_select_box">
                          <div className="input_box">
                            <div className="image_main_box">
                              <div className="imageWrapper">
                                <img
                                  className="image"
                                  src={
                                  selectedImage ||
                                  `${config.assestsBase}img/baraem_profile_img.png`
                                  }
                                  alt={
                                  selectedImage ?
                                  "Selected image" :
                                  "Displaying child logo"
                                  } />
                                
                              </div>
                            </div>
                            <label for="images1" className="file-upload">
                              <input
                                type="file"
                                className="file-input"
                                id="images1"
                                onChange={handleFileChange}
                                accept=".png, .jpg, .jpeg" />
                              
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                
                                <path
                                  d="M6.99984 2.91669V11.0834M2.9165 7.00002H11.0832"
                                  stroke="#002F70"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round" />
                                
                              </svg>
                              {selectedImage ?
                              translationMap?.imageUploadSuccessfully ??
                              "image uploaded successfully" :
                              translationMap?.uploadBaraemChildPhoto ??
                              "Upload your child photo for Baraam service (optional)"}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Inner_Box">
                    <div className="input_field_box">
                      <div className="input_inner_box">
                        <div className="row">
                          <div className="col-12 col-md-12 col-lg-12">
                            <div className="custom_input_box">
                              <label for="html">
                                {translationMap?.childName ?? "Child Name"}
                              </label>
                              <input
                                type="text"
                                name="childName"
                                placeholder={
                                isDubaiHealthFacility ?
                                patientFirstName :
                                translationMap?.childNamePlaceholder ??
                                "Write child’s name"
                                }
                                disabled={isDubaiHealthFacility}
                                className={`${
                                isDubaiHealthFacility ?
                                "input_field disable_field" :
                                "input_field"}`
                                }
                                value={childName}
                                maxLength={100}
                                onChange={handleChildNameChange} />
                              
                            </div>
                            {nameError &&
                            <span
                              style={{
                                color: "red",
                                display: "block"
                              }}>
                              
                                {translationMap?.errorMessageText ??
                              "This field is required"}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Inner_Box">
                    <div className="input_field_box">
                      <div className="input_inner_box">
                        <div className="row">
                          <div className="col-12 col-md-12 col-lg-6">
                            <div className="custom_input_box ">
                              <div className="input_box custom_date_box">
                                <label for="html">
                                  {translationMap?.childDOB ??
                                  "Childs date of birth"}
                                </label>
                                <div className="input_wrap">
                                  {!isDubaiHealthFacility &&
                                  <DatePicker
                                    selected={dob}
                                    placeholderText={
                                    translationMap?.dobPlaceholder ??
                                    "DD/MM/YYYY"
                                    }
                                    onChange={handleDobChange}
                                    maxDate={maxDate}
                                    className="date_input input_field"
                                    id="displayDateInput"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    dateFormat="dd/MM/yyyy"
                                    onKeyDown={(e) => {
                                      if (e.key === "Tab") {
                                        e.preventDefault();
                                        document
                                        .getElementById("male")
                                        ?.focus();
                                      }
                                    }}
                                    minDate={minDate}
                                    onFocus={(e) => e.target.blur()} />

                                  }
                                  {isDubaiHealthFacility &&
                                  <DatePicker
                                    selected={
                                    new Date(
                                      dateOfBirth
                                      .split("/")
                                      .reverse()
                                      .join("-")
                                    )
                                    .toISOString()
                                    .split("T")[0]
                                    }
                                    placeholderText={
                                    translationMap?.dobPlaceholder ??
                                    "DD/MM/YYYY"
                                    }
                                    className="date_input input_field disable_field"
                                    id="displayDateInput"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    dateFormat="dd/MM/yyyy"
                                    disabled={true} />

                                  }
                                </div>
                              </div>
                            </div>
                            {dobError &&
                            <span
                              style={{
                                color: "red",
                                display: "block"
                              }}>
                              
                                {translationMap?.errorMessageText ??
                              "This field is required"}
                              </span>
                            }
                          </div>
                          <div className="col-12 col-md-12 col-lg-6">
                            <div className="custom_input_box">
                              <label for="html">
                                {translationMap?.gender ?? "Gender"}{" "}
                              </label>
                              <div className="row">
                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="radio_box">
                                    <input
                                      type="radio"
                                      id="male"
                                      name="gender"
                                      value="M"
                                      checked={
                                      isDubaiHealthFacility ?
                                      patientSex === "M" :
                                      gender === "M"
                                      }
                                      disabled={isDubaiHealthFacility}
                                      onChange={handleGenderChange}
                                      className={`${
                                      isDubaiHealthFacility ?
                                      "disable_field" :
                                      ""}`
                                      } />
                                    
                                    <label htmlFor="male">
                                      {translationMap?.male ?? "Male"}
                                    </label>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="radio_box">
                                    <input
                                      type="radio"
                                      id="female"
                                      name="gender"
                                      value="F"
                                      checked={
                                      isDubaiHealthFacility ?
                                      patientSex === "F" :
                                      gender === "F"
                                      }
                                      disabled={isDubaiHealthFacility}
                                      onChange={handleGenderChange}
                                      className={`${
                                      isDubaiHealthFacility ?
                                      "disable_field" :
                                      ""}`
                                      } />
                                    
                                    <label htmlFor="female">
                                      {translationMap?.female ?? "Female"}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              {genderError &&
                              <span
                                style={{
                                  color: "red",
                                  display: "block"
                                }}>
                                
                                  {translationMap?.errorMessageText ??
                                "This field is required"}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="Inner_Box">
                    <div className="input_field_box">
                      <div className="input_inner_box">
                        <div className="row">
                          <div className="col-12 col-md-12 col-lg-6">
                            <div className="custom_input_box">
                              <label for="html">
                                {translationMap?.contactNumber ??
                                "Contact Number"}
                              </label>
                              <input
                                type="tel"
                                name="name"
                                disabled={true}
                                placeholder={
                                patientMobile !== "" ?
                                `+971 ${getLastNineCharacters(
                                  patientMobile
                                )}` :
                                "+971"
                                }
                                className="input_field disable_field" />
                              
                            </div>
                          </div>
                          <div className="col-12 col-md-12 col-lg-6">
                            <Country
                              country={nationality}
                              onChangeHandler={handleChangeNationality}
                              optionDefault={
                              translationMap?.nationalityPlaceholder ??
                              "please select nationality"
                              }
                              lable={
                              translationMap?.nationality ??
                              "please select nationality"
                              }
                              setCountryLoading={setCountryLoading}
                              translationMap={translationMap} />
                            
                            {countryCodeError &&
                            <span
                              style={{
                                color: "red",
                                display: "block"
                              }}>
                              
                                {translationMap?.errorMessageText ??
                              "This field is required"}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Inner_Box">
                    <div className="input_field_box">
                      <div className="input_inner_box">
                        <div className="row">
                          <div className="col-12 col-md-12 col-lg-6">
                            <div className="custom_input_box">
                              <label for="html">
                                {" "}
                                {translationMap?.nursery ??
                                "Nursery/School Name (optional)"}
                              </label>
                              <input
                                type="text"
                                name="name"
                                maxLength={100}
                                placeholder={
                                translationMap?.schoolPlaceholder ??
                                "Write facility name here"
                                }
                                className="input_field"
                                value={nurserySchoolName}
                                onChange={(e) => {
                                  const validValue = e.target.value.replace(
                                    /[^A-Za-z\u0600-\u06FF\s]/g,
                                    ""
                                  );
                                  setNurserySchoolName(validValue);
                                }} />
                              
                            </div>
                          </div>
                          <div className="col-12 col-md-12 col-lg-6">
                            <div className="custom_input_box">
                              <label for="html">
                                {translationMap?.followUpClinic ??
                                "Follow-up Clinic/Hospital (optional)"}
                              </label>
                              <input
                                type="text"
                                name="name"
                                maxLength={100}
                                placeholder={
                                translationMap?.followupPlaceholder ??
                                "Write facility name here"
                                }
                                className="input_field"
                                value={followUpHospital}
                                onChange={(e) => {
                                  const validValue = e.target.value.replace(
                                    /[^A-Za-z\u0600-\u06FF\s]/g,
                                    ""
                                  );
                                  setFollowUpHospital(validValue);
                                }} />
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Inner_Box">
                    <div className="input_field_box">
                      <div className="input_inner_box">
                        <div className="row">
                          <div className="col-12 col-md-12 col-lg-6">
                            <div className="custom_input_box">
                              <label htmlFor="html">
                                {translationMap?.bornIn ?? "Born in"}
                              </label>
                              <div className="row">
                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="radio_box">
                                    <input
                                      type="radio"
                                      id="baraemtest3"
                                      name="toggle"
                                      value="dubai"
                                      checked={hospital === "dubai"}
                                      onChange={() =>
                                      handleBornInChange("dubai")
                                      } />
                                    
                                    <label htmlFor="baraemtest3">
                                      {translationMap?.dubaiHealthHospital ??
                                      "Dubai Health Hospital"}
                                    </label>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="radio_box">
                                    <input
                                      type="radio"
                                      id="baraemtest4"
                                      name="toggle"
                                      value="other"
                                      checked={hospital === "other"}
                                      onChange={() =>
                                      handleBornInChange("other")
                                      } />
                                    

                                    <label htmlFor="baraemtest4">
                                      {translationMap?.otherHospital ??
                                      "Other Hospital"}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              {bornInError &&
                              <span
                                style={{
                                  color: "red",
                                  display: "block"
                                }}>
                                
                                  {translationMap?.errorMessageText ??
                                "This field is required"}
                                </span>
                              }
                            </div>
                          </div>
                          {bornInDubai === "dubai" &&
                          <div className="col-12 col-md-12 col-lg-6">
                              <div className="select_custom_box">
                                <label htmlFor="html">
                                  {translationMap?.selectHospital ??
                                "Select Hospital"}
                                </label>
                                <div className="dropdown-form">
                                  <select
                                  id="dropdown"
                                  value={bornIn}
                                  onChange={handleChangeHospital}>
                                  
                                    <option value="" disabled>
                                      {translationMap?.selecthospitalDropDown ??
                                    "Please select the hospital"}
                                    </option>
                                    {dubaiHospitalData.map((entry) =>
                                  <option key={entry.id} value={entry.key}>
                                        {isArabic() ?
                                    entry.name_i18n["ar-SA"] :
                                    entry.name_i18n["en-US"]}
                                      </option>
                                  )}
                                  </select>
                                </div>
                                {hospitalError &&
                              <span
                                style={{
                                  color: "red",
                                  display: "block"
                                }}>
                                
                                    {translationMap?.errorMessageText ??
                                "This field is required"}
                                  </span>
                              }
                              </div>
                            </div>
                          }
                          {bornInDubai === "other" &&
                          <div className="col-12 col-md-12 col-lg-6">
                              <div className="select_custom_box">
                                <label htmlFor="html">
                                  {translationMap?.otherHospitalLabel ??
                                "Please specify which hospital"}
                                </label>
                                <div className="dropdown-form">
                                  <select
                                  id="dropdown"
                                  value={bornIn}
                                  onChange={handleChangeHospital}>
                                  
                                    <option value="" disabled>
                                      {translationMap?.selecthospitalDropDown ??
                                    "Please select the hospital"}
                                    </option>
                                    {otherHospitalsData.map((entry) =>
                                  <option key={entry.id} value={entry.key}>
                                        {isArabic() ?
                                    entry.name_i18n["ar-SA"] :
                                    entry.name_i18n["en-US"]}
                                      </option>
                                  )}
                                  </select>
                                </div>
                                {hospitalError &&
                              <span
                                style={{
                                  color: "red",
                                  display: "block"
                                }}>
                                
                                    {translationMap?.errorMessageText ??
                                "This field is required"}
                                  </span>
                              }
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Inner_Box">
                    <div className="input_field_box">
                      <div className="input_inner_box">
                        <div className="row custom_row">
                          <div className="col-12 col-md-12 col-lg-6">
                            <div className="custom_input_box">
                              <label htmlFor="html">
                                {translationMap?.childAlreadyDiagnosed ??
                                "Is your child already diagnosed with a disability/developmental delay?"}
                              </label>
                              <div className="row">
                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="radio_box">
                                    <input
                                      type="radio"
                                      id="diagnosedNo"
                                      name="diagnosis"
                                      checked={disabilities === "no"} // Now storing "yes" or "no" in disabilities
                                      onChange={() =>
                                      handleDiagnosisChange("no")
                                      } />
                                    
                                    <label htmlFor="diagnosedNo">
                                      {translationMap?.no ?? "No"}
                                    </label>
                                  </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                  <div className="radio_box">
                                    <input
                                      type="radio"
                                      id="diagnosedYes"
                                      name="diagnosis"
                                      checked={disabilities === "yes"} // Now storing "yes" or "no" in disabilities
                                      onChange={() =>
                                      handleDiagnosisChange("yes")
                                      } />
                                    
                                    <label htmlFor="diagnosedYes">
                                      {translationMap?.yes ?? "Yes"}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              {disabilityError &&
                              <span
                                style={{
                                  color: "red",
                                  display: "block"
                                }}>
                                
                                  {" "}
                                  {translationMap?.errorMessageText ??
                                "This field is required"}
                                </span>
                              }
                            </div>
                          </div>
                          {isDiagnosed === "yes" &&
                          <div className="col-12 col-md-12 col-lg-6">
                              <div className="select_custom_box">
                                <label htmlFor="disabilitySelect">
                                  {translationMap?.selectDisability ??
                                "Select disability/developmental delay"}{" "}
                                </label>
                                <div className="dropdown-form">
                                  <select
                                  id="dropdown"
                                  value={diagnosedDisability}
                                  onChange={handleDisabilities}>
                                  
                                    <option value="" disabled>
                                      {" "}
                                      {translationMap?.selectDisabilityPlaceholder ??
                                    "Please select disability"}
                                    </option>
                                    {disabillitiesList.map((entry) =>
                                  <option key={entry.id} value={entry.key}>
                                        {isArabic() ?
                                    entry.name_i18n["ar-SA"] :
                                    entry.name_i18n["en-US"]}{" "}
                                      </option>
                                  )}
                                  </select>
                                </div>
                              </div>
                              {selectdisabilityError &&
                            <span
                              style={{
                                color: "red",
                                display: "block"
                              }}>
                              
                                  {translationMap?.errorMessageText ??
                              "This field is required"}
                                </span>
                            }
                            </div>
                          }
                        </div>
                        {isDiagnosed === "yes" &&
                        diagnosedDisability === "other" &&
                        <div className="row custom_row">
                              <div className="col-12 col-md-12 col-lg-12">
                                <div className="custom_input_box">
                                  <label htmlFor="otherDisease">
                                    {translationMap?.pleaseSpecifyDisease ??
                                "Please specify the disease"}
                                  </label>
                                  <input
                                type="text"
                                id="otherDisease"
                                placeholder={
                                translationMap?.writeDetailsText ??
                                "Write more details here"
                                }
                                className="input_field"
                                value={otherDisability}
                                maxLength={100}
                                onChange={(e) => {
                                  const validValue = e.target.value.replace(
                                    /[^A-Za-z\u0600-\u06FF\s]/g,
                                    ""
                                  );
                                  setOtherDisability(validValue);
                                  setOtherDisabilityError(false);
                                }} />
                              
                                </div>
                                {otherDisabilityError &&
                            <span
                              style={{
                                color: "red",
                                display: "block"
                              }}>
                              
                                    {translationMap?.errorMessageText ??
                              "This field is required"}
                                  </span>
                            }
                              </div>
                            </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="Inner_Box">
                    <div className="input_field_box">
                      <div className="input_inner_box">
                        <div className="row">
                          <div className="col-12 col-md-12 col-lg-6">
                            <div className="select_custom_box">
                              <label for="html">
                                {translationMap?.whatWasDurationOfPregnancy ??
                                "What was the duration of the pregnancy"}
                              </label>
                              <div className="dropdown-form">
                                <select
                                  id="dropdown"
                                  value={prematurity}
                                  onChange={handlePrematurityWeekChange}>
                                  
                                  <option value="" disabled>
                                    {translationMap?.select ?? "Select"}
                                  </option>
                                  {pregnancyDurationList.map((entry) =>
                                  <option key={entry.id} value={entry.key}>
                                      {isArabic() ?
                                    entry.name_i18n["ar-SA"] :
                                    entry.name_i18n["en-US"]}
                                    </option>
                                  )}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="Inner_Box">
                    <div className="form_buton_box">
                      <span>
                        <button
                          type="submit"
                          className={
                          isAddButtonDisable ?
                          "disabled_btn_link" :
                          "blue_btn_link"
                          }
                          disabled={isAddButtonDisable}>
                          
                          {translationMap?.addChild ?? "Add Child"}
                        </button>
                      </span>
                      <span>
                        <button
                          onClick={() => {
                            setStep(-1);
                            window.parent.scrollTo(0, 0);
                          }}
                          className="bluetrans_btn_link">
                          
                          {translationMap?.back ?? "Back"}
                        </button>
                      </span>
                      <span>
                        <button
                          onClick={() => navigate("/")}
                          className="Orangetrans_btn_link">
                          
                          {translationMap?.cancel ?? "Cancel"}
                        </button>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="cover_main_box2"></div>
          </div>
        </div>
      </section>
      {showAddChildPopup &&
      <ChildAddedPopup
        childName={isDubaiHealthFacility ? patientFirstName : childName}
        age={ageInMonths}
        setShowAddChildPopup={setShowAddChildPopup}
        translationMap={translationMap}
        selectedImage={selectedImage}
        gender={isDubaiHealthFacility ? patientSex : gender} />

      }
    </div>);

};

export default AddNonDubaiHealthChild;